module.exports = __webpack_public_path__ + "static/media/join_list_banner.1ae6f4f3.svg";